import { render } from "./Addforwardemail.vue?vue&type=template&id=7ccd228c"
import script from "./Addforwardemail.vue?vue&type=script&lang=js"
export * from "./Addforwardemail.vue?vue&type=script&lang=js"

import "./Addforwardemail.vue?vue&type=style&index=0&id=7ccd228c&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__